import { FC, memo, useState } from 'react';
import classNames from 'classnames';
import { keys, noop } from 'lodash';
import { useTranslation } from 'react-i18next';
// Import UI components
import { Button, Icon, Paper } from '@geneui/components';
// Import Enums
import { SaveModesEnum } from 'enums';
// Import Styles
import 'assets/scss/buttonWithDropDown.scss';

interface Props {
    name: string;
    color?: 'confirm' | 'default' | 'primary' | 'danger';
    disabled?: boolean;
    containerClassName?: string;
    buttonWithDropDownConfig?: object;
    handleSave?: () => void;
    setSaveButtonLabel?: (label: string) => void;
}

const ButtonWithDropDown: FC<Props> = (props) => {
    const {
        color = 'confirm',
        name,
        disabled = true,
        containerClassName = '',
        buttonWithDropDownConfig = {},
        handleSave = noop,
        setSaveButtonLabel = noop,
    } = props;

    const { t } = useTranslation();
    const [openDropDown, setOpenDropDown] = useState(false);

    const handleIconClick = () => {
        setOpenDropDown(!openDropDown);
    };

    const handleAdditionalSettingChoose = (label: string) => {
        return () => {
            setOpenDropDown(false);
            setSaveButtonLabel(label);
            handleSave();
        };
    };

    const saveHandler = () => {
        setSaveButtonLabel(SaveModesEnum.SaveAsLive);
        handleSave();
    };

    return (
        <div className={classNames('crm-button-with-dropdown', { [containerClassName]: containerClassName })}>
            <Button flexibility="default" size="default" color={color} onClick={saveHandler} disabled={disabled}>
                {name}
            </Button>
            <div className="crm-button-with-dropdown_icon-box">
                <Icon onClick={handleIconClick} type={`bc-icon-arrow-${!openDropDown ? 'down' : 'up'}`} />
            </div>
            {openDropDown && (
                <div className="crm-button-with-dropdown_dropdown-box">
                    {keys(buttonWithDropDownConfig).map((label, key) => (
                        // TODO: remove paper
                        <Paper
                            key={key}
                            onClick={handleAdditionalSettingChoose(label)}
                            className="crm-button-with-dropdown_dropdown-box_content-box"
                        >
                            <p>{t(label)}</p>
                        </Paper>
                    ))}
                </div>
            )}
        </div>
    );
};

export default memo(ButtonWithDropDown);
